import AccountSelection from './AccountSelection';
import { useBank } from './useBank';
import { useAccountSelection } from './useAccountSelection';
import { useAppSelector } from '../../app/hooks';
import { selectAccounts } from '../../app/slices/account.slice';
import { Account } from '../../types/account';

const AccountSelectionStep = () => {
	const accounts = useAppSelector(selectAccounts) as Array<Account>;
	const { bankName, bankCode, bankLogo } = useBank();
	const { selectedAccount, onAccountSelect, onContinue } = useAccountSelection();

	return (
		<AccountSelection
			accounts={accounts}
			selectedAccount={selectedAccount}
			bankCode={bankCode}
			bankLogo={bankLogo}
			bankName={bankName}
			onAccountSelect={onAccountSelect}
			onContinue={onContinue}
		/>
	);
};

export default AccountSelectionStep;
